import PropTypes from 'prop-types';
import React from 'react';
// import { propTypes as rowPropTypes } from './row';
import FeaturedCard from '../card/featured_card';
import ModuleTitle from '../module/module_title';
import {
  CHANNEL_COLORS,
  DEFAULT_COLORS
} from '../common/aggregation_page_colors';
import getUniqueKeyForCard from '../../utils/getUniqueKeyForCard';
import withViewportScrollTracking from '../hocs/withViewportScrollTracking';
import {get, find, map, take, times} from 'lodash';

export const ThreeFeaturedCardsRow = ({
  cards,
  dataAttributes,
  page_id,
  type,
  isHomepageRefresh
}, { isPreviewPage }) => {
  const threeFeaturedCards = map(take(cards, 3), (card, i) => {
    const cardProps = {
      key: getUniqueKeyForCard(card, isPreviewPage),
      rowType: type,
      firstInRow: i === 0,
      page_id,
      isHomepageRefresh,
      ...card
    };
    return <FeaturedCard {...cardProps} />;
  });

  return (
    <div className="featured-stories" {...dataAttributes} >
      {isHomepageRefresh && <ModuleTitle title="Editor's Picks" />}
      {threeFeaturedCards}
      {!isHomepageRefresh && <span className="stripe"/>}
    </div>
  );
};

// ThreeFeaturedCardsRow.propTypes = Object.assign({ ...rowPropTypes }, {
//   dataAttributes: PropTypes.object.isRequired
// });

ThreeFeaturedCardsRow.defaultProps = {
  dataAttributes: {}
};

ThreeFeaturedCardsRow.contextTypes = {
  isPreviewPage: PropTypes.bool.isRequired
};

const decorator = withViewportScrollTracking({
  eventParams: () => [
    'Scroll Depth',
    'Scroll',
    'Reached Featured Stories'
  ]
});

export default decorator(ThreeFeaturedCardsRow);
